/** Build a usable iframe embed URL from configured map_url and/or address text. */
export function buildMapEmbedSrc(mapUrl: string | null | undefined, address: string): string | null {
  const trimmedAddress = address.trim();
  const url = (mapUrl || "").trim();

  if (url) {
    if (/\/maps\/embed/i.test(url) || /[?&]output=embed\b/i.test(url)) {
      return url;
    }
    if (/google\.[^/]*\/maps/i.test(url)) {
      const q = trimmedAddress || url;
      return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
    }
    if (/openstreetmap\.org/i.test(url)) {
      try {
        const u = new URL(url);
        const mlat = u.searchParams.get("mlat");
        const mlon = u.searchParams.get("mlon");
        if (mlat && mlon) {
          const lat = Number(mlat);
          const lon = Number(mlon);
          const delta = 0.02;
          return `https://www.openstreetmap.org/export/embed.html?bbox=${lon - delta}%2C${lat - delta}%2C${lon + delta}%2C${lat + delta}&layer=mapnik&marker=${lat}%2C${lon}`;
        }
      } catch {
        /* fall through */
      }
    }
    if (trimmedAddress) {
      return `https://www.google.com/maps?q=${encodeURIComponent(trimmedAddress)}&output=embed`;
    }
  }

  if (trimmedAddress) {
    return `https://www.google.com/maps?q=${encodeURIComponent(trimmedAddress)}&output=embed`;
  }
  return null;
}
